import {
  collection,
  query,
  getDocs,
  getDocsFromServer,
} from "firebase/firestore";
import { db } from "../../firebase";
import { EntityGet, EntityServerGet, ListServiceOpts } from "../../types";
import { Calendarevent } from "./types";
import { transformMetadata, processTimestampFields } from "../../utils";

export type CalendareventListService<T> = (
  agentId: string,
  opts?: ListServiceOpts
) => Promise<Array<T>>;

const list: CalendareventListService<EntityGet<Calendarevent>> = async (
  agentId,
  opts = {}
) => {
  const collectionRef = collection(db, `/agent/${agentId}/calendarevent`);
  const { disableCache } = opts;
  const q =
    typeof opts.listQueryFn === "function"
      ? opts.listQueryFn(collectionRef)
      : query(collectionRef);
  const getFn = disableCache ? getDocsFromServer : getDocs;
  const querySnapshot = await getFn(q);
  return querySnapshot.docs.map((doc) => {
    return processTimestampFields(
      transformMetadata({
        ...doc.data(),
        id: doc.id,
      } as EntityServerGet<Calendarevent>)
    ) as EntityGet<Calendarevent>;
  });
};

export default list;
